import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class IconService {
    constructor() {

    }

    signatureIcon(signature_type) {

    }

    evidenceIcon(evidence_type) {
        switch (evidence_type) {
            case "email_processed": return 'icon-send';
            case "email_delivered": return 'icon-send';
            case "email_dropped": return 'icon-x-circle';
            case "email_deferred": return 'icon-x-circle';
            case "email_bounce": return 'icon-x-circle';
            case "email_open": return 'icon-book-open';
            case "email_click": return 'icon-book-open';
            case "sms_sent": return 'icon-send';
            case "doc_open": return 'icon-eye';
            case "envelope_doc_open": return 'icon-eye';
            case "doc_sign": return 'icon-signature';
            case "doc_decline": return 'icon-x-close';
            case "kyc_manual": return 'icon-smile';
            case "kyc_auto": return 'icon-smile';
            case "kyc_prevalidated": return 'icon-smile';
            case "kyc_unprevalidated": return 'icon-smile';
            case "kyc_status_set": return 'icon-smile';
            case "otp_sent": return 'icon-send-to-device';
            case "otp_received": return 'icon-send-to-device';
            case "otp_email_sent": return 'icon-send';
            case "file_attachment": return 'icon-paperclip';
            case "receiver_added": return 'icon-plus';
            case "receiver_edited": return 'icon-edit';
            case "receiver_deleted": return 'icon-trash';
            case "validation_requested": return 'icon-mail';
            case "validation_accepted": return 'icon-check-circle';
            case "validation_rejected": return 'icon-x-circle';
            case "add_comment": return 'icon-add-comment';
            case "edit_comment": return 'icon-add-comment';
            case "delete_comment": return 'icon-trash';
            case "reply_comment": return 'icon-add-comment';
            case "match_document_id": return 'icon-check-circle';
            case "validate_custom_fields": return 'icon-check-circle';
            case "cancel_document": return 'icon-x-circle';
            case "policy_checks": return 'icon-check-circle';
            case "policy_checks_external": return 'icon-check-circle';
            case "observer_requested": return 'icon-eye';
            case "observer_accept": return 'icon-check-circle';
            case "observer_reject": return 'icon-x-circle';
            default: return 'icon-check';
        }
    }
}